import { ValidationMessageTemplate, ValidationRuleFunction, ValidationRuleSchema } from "vee-validate/dist/types/types"

import { hashSHA256Validator } from "./hashSHA256Validator"
import { customMessage } from "./validatorUtil"

export class HashSHA256RuleSchema implements ValidationRuleSchema {
  validate: ValidationRuleFunction = value => {
    return hashSHA256Validator(value)
  }
  message: ValidationMessageTemplate = (field: string, params?: Record<string, any>) => {
    return customMessage(field, params)
  }
}
